module.exports = __webpack_public_path__ + "img/ic_icon_card_prepago.a41d131c.png";